import React from "react";
import { Body1 } from "@iventis/styles";
import { CONTACT_URL } from "@iventis/utilities";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";
import { StyledHeader1, StyledErrorImage, StyledButton, ButtonContainer, ErrorContainer } from "./error-boundary-styles";

/**
 * Error boundary fallback component for connection-related errors.
 * Always has reload action.
 */
export const ErrorBoundaryFallbackConnection: React.FC = () => {
    const translate = useIventisTranslate();

    return (
        <ErrorContainer>
            <StyledErrorImage />
            <StyledHeader1>{translate(Content.errors.error_boundaries.connection_error_title)}</StyledHeader1>
            <Body1>
                {translate(Content.errors.error_boundaries.connection_error_message)}
                <br />
            </Body1>
            <ButtonContainer>
                <StyledButton href={CONTACT_URL} variant="outlined">
                    {translate(Content.errors.error_boundaries.contact)}
                </StyledButton>
                <StyledButton onClick={() => window.location.reload()}>{translate(Content.errors.error_boundaries.reload)}</StyledButton>
            </ButtonContainer>
        </ErrorContainer>
    );
};
